import { render, staticRenderFns } from "./RankingMore.vue?vue&type=template&id=1d872f31&scoped=true"
import script from "./RankingMore.vue?vue&type=script&lang=js"
export * from "./RankingMore.vue?vue&type=script&lang=js"
import style0 from "./RankingMore.vue?vue&type=style&index=0&id=1d872f31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d872f31",
  null
  
)

export default component.exports